export default __webpack_public_path__ + "static/media/heart.47daf9b7.svg";